/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import BaseWidget from 'scripts/base-widget';
import can from 'can';
import appContext from 'scripts/app-context';
import 'can/view/view';
import 'components/timeline/timeline';

export const PlayerLatest = BaseWidget.extend({
    init: function () {
        this.viewModel = {
            options: new can.Map({identifier: this.options.player.identifier}),
            dataAvailable(scope, $element, event, isAvailable) {
                appContext.model.attr('playerLatestIsAvailable', isAvailable);
            }
        };
        this.view = can.stache('<timeline title="Latest" type="player" {options}="options" (dataAvailable)="dataAvailable"></timeline>');
        this._super();
    }
});
